import {ChangeDetectorRef, Component, Input, OnInit} from '@angular/core';
import {Category, Image, Product, RoutingService} from '@spartacus/core';
import {CurrentProductService} from '@spartacus/storefront';
import {DcpProductUtilitiesService} from '../../../services/dcp-product-utilities.service';
import {UntilDestroy, untilDestroyed} from '@ngneat/until-destroy';
import {CategoryService} from '@app/services/category.service';

@UntilDestroy()
@Component({
  selector: 'dcp-product-name-display',
  templateUrl: './product-name-display.component.html',
  styleUrls: ['./product-name-display.component.scss']
})
export class ProductNameDisplayComponent implements OnInit {
  @Input() productInput;

  product: Product;
  image: Image;
  categories: Category[];
  displayedCategory: Category;

  constructor(
    public productUtils: DcpProductUtilitiesService,
    private currentProductService: CurrentProductService,
    private changeDetector: ChangeDetectorRef,
    private routingService: RoutingService,
    private categoryService: CategoryService
  ) {
  }

  ngOnInit(): void {
    if (this.productInput) {
      this.initializeProduct(this.productInput);
    } else {
      this.currentProductService.getProduct().pipe(untilDestroyed(this)).subscribe(product => {
        this.initializeProduct(product);
      });
    }
  }

  initializeProduct(product: Product): void {
    this.product = product;
    this.image = this.productUtils.getPrimaryImg(product);
    if(this.product?.categories) {
      this.categories = this.product.categories.filter(category => this.categoryService.isDisplayed(category));
      this.displayedCategory = this.categories[this.categories.length - 1];
    };
    this.changeDetector.detectChanges();
  }

  showProductsForCategory(categoryId: string): void {
    this.categoryService.displayProductsOfCategory(categoryId);
  }

  launchSearchResult(): void {
    this.routingService.go({
        cxRoute: 'search',
        params: {
          query: '',
        },
      },
      {
        queryParams: {
          sortCode: 'relevance'
        }
      }
    );
  }
}
